import React, {useEffect, useReducer, useState} from 'react';
import clsx from "clsx";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import {Avatar, Badge, Paper} from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import CalendarTodayTwoToneIcon from '@mui/icons-material/CalendarTodayTwoTone';
import EventAvailableTwoToneIcon from '@mui/icons-material/EventAvailableTwoTone';
import Divider from "@mui/material/Divider";
import BathtubTwoToneIcon from "@mui/icons-material/BathtubTwoTone";
import EventNoteTwoToneIcon from '@mui/icons-material/EventNoteTwoTone';
import CalendarViewDayTwoToneIcon from '@mui/icons-material/CalendarViewDayTwoTone';
import EventBusyTwoToneIcon from '@mui/icons-material/EventBusyTwoTone';
import ContactMailTwoToneIcon from '@mui/icons-material/ContactMailTwoTone';
import NoMeetingRoomTwoToneIcon from '@mui/icons-material/NoMeetingRoomTwoTone';
import PriorityHighTwoToneIcon from '@mui/icons-material/PriorityHighTwoTone';
import DirectionsCarTwoToneIcon from '@mui/icons-material/DirectionsCarTwoTone';
import LocalHospitalTwoToneIcon from '@mui/icons-material/LocalHospitalTwoTone';
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';
import {initTamponiState, TAMPONI_INITIAL_STATE, TamponiReducer} from "../../../../reducers/TamponiReducer";
import {getInfoPrenotazioni} from "../../../../services/TamponiServices";
import moment from "moment";
import {addDayToDate} from "../../../../utils/GenericUtils";
import {grey} from "@mui/material/colors";
import {BusinessTwoTone, PermContactCalendarTwoTone} from "@mui/icons-material";

const PrenotazioniDrawer = ({
	                            selectMenuItem,
	                            stato,
	                            dataRichiesta,
	                            priority,
	                            handlePriority,
	                            active,
	                            setActiveFilter,
	                            criterio,
	                            setCriterio,
	                            contattoRich,
	                            setContattoRich,
	                            luogo,
	                            setLuogo
                            }) => {
	const classes = BaseStyle();
	const [open, setOpen] = useState(true);
	const [tamponiState, tamponiDispatch] = useReducer(TamponiReducer, TAMPONI_INITIAL_STATE, initTamponiState);

	const handleDrawerOpenClose = () => {
		setOpen(!open);
	};

	useEffect(() => {
        getInfoPrenotazioni(tamponiDispatch, {tipo: luogo});
	}, [tamponiDispatch, dataRichiesta, stato, luogo]);


	return (
        <React.Fragment>
            <Paper
				className={clsx(classes.drawer, classes.roundBorder, open ? classes.openDrawer : classes.closedDrawer)}>
				<div style={{display: "flex", justifyContent: "center"}}>
					<Tooltip title={open ? "Comprimi menù" : "Espandi menù"}>
						<IconButton onClick={handleDrawerOpenClose} size="large">
							{!open ? <ChevronRightIcon/> : <ChevronLeftIcon/>}
						</IconButton>
					</Tooltip>
				</div>
				<List>
					<ListItem button className={classes.roundBorder} selected={stato === "Odierni"}
					          onClick={() => selectMenuItem("Odierni")}>
						<ListItemIcon>
							<Badge showZero badgeContent={tamponiState.infoPrenotazioni?.todayCount} color="primary"
							       max={9999}>
								<CalendarTodayTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"Odierni"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={stato === "Da confermare"}
					          onClick={() => selectMenuItem("Da confermare")}>
						<ListItemIcon>
							<Badge showZero badgeContent={tamponiState.infoPrenotazioni?.approvalCount} color="primary"
							       max={99999}>
								<CalendarTodayTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"Da confermare"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={stato === "Conclusi"}
					          onClick={() => selectMenuItem("Conclusi")}>
						<ListItemIcon>
							<Badge showZero badgeContent={tamponiState.infoPrenotazioni?.doneCount} color="primary"
							       max={9999}>
								<EventAvailableTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"Conclusi"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={stato === "Annullati"}
					          onClick={() => selectMenuItem("Annullati")}>
						<ListItemIcon>
							<Badge showZero badgeContent={tamponiState.infoPrenotazioni?.deletedCount} color="primary"
							       max={9999}>
								<EventBusyTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"Annullati"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={stato === "Tutti"}
					          onClick={() => selectMenuItem("Tutti")}>
						<ListItemIcon>
							<Badge showZero badgeContent={tamponiState.infoPrenotazioni?.totalCount} color="primary"
							       max={9999}>
								<ContactMailTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"Tutti"}/>
					</ListItem>
				</List>
				<Divider/>
				<List>
					<ListItem button className={classes.roundBorder} selected={luogo === "Agenda personale"}
					          onClick={() => setLuogo(luogo === "Agenda personale" ? null : "Agenda personale")}>
						<ListItemIcon>
							<PermContactCalendarTwoTone/>
						</ListItemIcon>
						<ListItemText primary={"Agenda personale"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={luogo === "Agenda globale"}
					          onClick={() => setLuogo(luogo === "Agenda globale" ? null : "Agenda globale")}>
						<ListItemIcon>
							<BusinessTwoTone/>
						</ListItemIcon>
						<ListItemText primary={"Agenda globale"}/>
					</ListItem>
				</List>

				<Divider/>
				<List>
					<ListItem button className={classes.roundBorder} selected={active === "true"}
					          onClick={() => setActiveFilter(active === "true" ? "false" : "true")}>
						<ListItemIcon>
							<Badge showZero badgeContent={tamponiState.infoPrenotazioni?.["In corso"]} color="primary"
							       max={9999}>
								<BathtubTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"In corso"}/>
					</ListItem>
				</List>
				<Divider/>
				<List>
					<ListItem button className={classes.roundBorder} selected={stato === "Crea agenda"}
					          onClick={() => selectMenuItem("Crea agenda")}>
						<ListItemIcon>
							<CalendarViewDayTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"Crea agenda"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={stato === "Visualizza agende"}
					          onClick={() => selectMenuItem("Visualizza agende")}>
						<ListItemIcon>
							<EventNoteTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"Visualizza agende"}/>
					</ListItem>
				</List>
			</Paper>
        </React.Fragment>
    );
};

export default React.memo(PrenotazioniDrawer)
